<template>
  <div
    class="b-card b-card_main js-sleep-card"
    :class="{ 'is-active': isActiveProduct }"
  >
    <div class="b-card__content block-products">
      <div class="b-card__top">
        <div class="product-card-action-container">
          <a href="javascript:void(0)" class="product-card-action js-popup-link"
            >-25% на комплект для сна</a
          >
        </div>
        <a :href="getProductUrl" target="_blank" class="b-card__image">
          <span class="b-card__image-picture">
            <img
              class="js-view-image lazyloaded"
              :alt="this.product.NAME"
              :title="this.product.NAME"
              :data-src="this.product.PREVIEW_PICTURE"
              :src="this.product.PREVIEW_PICTURE"
            />
          </span>
        </a>
      </div>
      <div class="b-card__center">
        <div class="b-card__price">
          <div class="g-price">
            {{ this.getPrice }} <span class="g-price__rub">₽</span>
          </div>
        </div>

        <a :href="getProductUrl" class="b-card__name">
          {{ this.product.NAME }}
        </a>

        <div class="b-card-size-wrapper">
          Размер:
          <span
            v-for="size in getSizeList"
            :key="size.ID"
            @click="selectSize(size, true)"
            class="b-card-size"
            :class="{ 'is-active': this.offerId === size.ID }"
            >{{ size.SIZE }}</span
          >
        </div>
      </div>
      <div class="b-card__bottom">
        <div
          @click="selectOffer"
          class="button button_primary button_md w-100 fs-14 fw-medium text-uppercase sleep-card-button"
          :class="{
            'is-active': isActiveProduct,
          }"
        >
          <span v-if="isActiveProduct" class="d-md-none"
            >добавлено в комплект</span
          >
          <span v-if="isActiveProduct" class="d-none d-md-block"
            >в комплекте</span
          >
          <span v-if="!isActiveProduct" class="d-md-none">выбрать</span>
          <span v-if="!isActiveProduct" class="d-none d-md-block">выбрать</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useBundleStore } from "@/sleep_bundle/stores/bundle";

export default {
  name: "BundlePoolItem",
  data() {
    return {
      offerId: 0,
      offer: {},
    };
  },
  setup() {
    const store = useBundleStore();

    return {
      store,
    };
  },
  props: {
    product: Object,
    number: Number,
  },
  methods: {
    selectSize(size, refresh = false) {
      this.offerId = size.ID;
      this.offer = size;

      if (refresh) {
        this.store.selected["offer" + this.number] = {};
      }
    },
    async selectOffer() {
      if (this.offerId === 0) {
        this.selectSize(this.getSizeList[0]);
      }
      this.store.selected["offer" + this.number] = this.offer;
    },
  },
  computed: {
    getProductUrl() {
      return "/product/" + this.product.CODE + "/";
    },
    getSizeList() {
      const sizeList = Object.values(this.store.offer).filter((offer) => {
        return offer.PRODUCT_ID === this.product.ID;
      });

      return sizeList.sort(function (a, b) {
        return Number(a.SIZE_ID) > Number(b.SIZE_ID) ? 1 : -1;
      });
    },
    getSelectedOffer() {
      return this.store.selected["offer" + this.number];
    },
    isActiveProduct() {
      return this.getSelectedOffer.PRODUCT_ID === this.product.ID;
    },
    getPrice() {
      const availabilityItem = Object.values(this.store.availability).filter(
        (record) => {
          return this.offerId > 0
            ? record.UF_SKU_ID === this.offerId
            : record.UF_PRODUCT_ID === this.product.ID;
        }
      );

      return Number(availabilityItem[0]["UF_PRICE_CURRENT"]).toLocaleString(
        "ru-RU"
      );
    },
  },
};
</script>
